export default function getChecklistFigureData(entry) {
  if (!entry?.checklistFiguresHomeLoggedOut?.length) return null
  const data = []
  entry?.checklistFiguresHomeLoggedOut.forEach((item) => {
    const itemObj = {}
    itemObj.reversed = !item?.checklistFigureReversed || false
    itemObj.figure = item?.checklistFigureImage?.[0] || false
    itemObj.title = item?.checklistFigureTitle || false
    itemObj.description =
      (typeof item?.checklistFigureText === 'string' ? item.checklistFigureText : item?.checklistFigureText?.html) ||
      false
    itemObj.listItems = item?.checklistFigureList?.length ? [] : false
    if (itemObj.listItems) {
      item?.checklistFigureList.forEach((listItem) => {
        itemObj.listItems.push(listItem.text)
      })
    }
    itemObj.button = item?.optionalButton?.[0]?.button ? {} : false
    if (itemObj.button) {
      itemObj.button.href = item?.optionalButton?.[0]?.button?.url || '#'
      itemObj.button.label = item?.optionalButton?.[0]?.button?.text || ''
      itemObj.button.icon = { id: 'icon-chevron-right' }
      itemObj.button.modifiers = ['Button--checklistFigure']
    }

    data.push(itemObj)
  })
  return data
}
